import { useSlots as L, computed as d, getCurrentInstance as w, openBlock as m, createBlock as u, resolveDynamicComponent as x, mergeProps as P, withKeys as T, withCtx as n, unref as y, renderSlot as r, createVNode as s, createCommentVNode as b, createTextVNode as l, toDisplayString as f } from "vue";
import I from "./design-system.es62.js";
import V from "./design-system.es94.js";
import k from "./design-system.es58.js";
import c from "./design-system.es106.js";
import { createActionsProvider as A } from "./design-system.es31.js";
import { useListContext as E } from "./design-system.es34.js";
/* empty css                    */
import K from "./design-system.es128.js";
const j = /* @__PURE__ */ Object.assign({
  name: "DsListItemNext"
}, {
  __name: "ListItemNext",
  props: {
    /**
     * Root element type
     */
    as: {
      type: String,
      default: "div"
    },
    /**
     * Overline text
     */
    overline: {
      type: String,
      default: ""
    },
    /**
     * Title text
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Description text
     */
    description: {
      type: String,
      default: ""
    },
    /**
     * Leading icon
     */
    leadingIcon: {
      type: String,
      default: null
    },
    /**
     * Trailing icon
     */
    trailingIcon: {
      type: String,
      default: null
    },
    border: {
      type: String,
      default: null,
      options: ["none", "inset", "fill"]
    },
    /**
     * Determines if the list item is selected
     */
    selected: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  setup(i, { emit: S }) {
    const o = i, g = S, p = L(), a = E(), C = d(() => !!o.border), v = d(() => o.border ? o.border : a != null && a.border ? a.border : !1), $ = d(() => {
      var t, e;
      return (e = (t = w()) == null ? void 0 : t.vnode.props) != null && e.onClick && o.as !== "a" ? {
        role: "listitem",
        tabindex: 0
      } : {};
    }), { containsEventTarget: N } = A();
    function D(t) {
      N(t) || g("click", t);
    }
    function B(t) {
      o.as !== "a" && g("click", t);
    }
    return (t, e) => (m(), u(x(i.as), P($.value, {
      class: ["ds-list-item", {
        "ds-list-item--border-fill": v.value === "fill",
        "ds-list-item--border-inset": v.value === "inset",
        "ds-list-item--border-local": C.value,
        "ds-list-item--selected": i.selected
      }],
      onClick: D,
      onKeydown: T(B, ["enter"])
    }), {
      default: n(() => [
        i.leadingIcon || y(p).leading ? (m(), u(I, {
          key: 0,
          class: "ds-list-item-leading"
        }, {
          default: n(() => [
            r(t.$slots, "leading", {}, () => [
              s(k, { name: i.leadingIcon }, null, 8, ["name"])
            ], !0)
          ]),
          _: 3
        })) : b("", !0),
        e[3] || (e[3] = l()),
        s(V, { fill: "" }, {
          default: n(() => [
            r(t.$slots, "default", {}, () => [
              s(c, {
                variant: "headline-5",
                class: "ds-list-item-overline"
              }, {
                default: n(() => [
                  r(t.$slots, "overline", {}, () => [
                    l(f(i.overline), 1)
                  ], !0)
                ]),
                _: 3
              }),
              e[0] || (e[0] = l()),
              s(c, {
                variant: "body",
                class: "ds-list-item-title ds-list-item-line-clamp"
              }, {
                default: n(() => [
                  r(t.$slots, "title", {}, () => [
                    l(f(i.title), 1)
                  ], !0)
                ]),
                _: 3
              }),
              e[1] || (e[1] = l()),
              s(c, {
                variant: "body-2",
                class: "ds-list-item-description ds-list-item-line-clamp"
              }, {
                default: n(() => [
                  r(t.$slots, "description", {}, () => [
                    l(f(i.description), 1)
                  ], !0)
                ]),
                _: 3
              }),
              e[2] || (e[2] = l()),
              r(t.$slots, "footer", {}, void 0, !0)
            ], !0)
          ]),
          _: 3
        }),
        e[4] || (e[4] = l()),
        i.trailingIcon || y(p).trailing ? (m(), u(I, {
          key: 1,
          class: "ds-list-item-trailing"
        }, {
          default: n(() => [
            r(t.$slots, "trailing", {}, () => [
              s(k, { name: i.trailingIcon }, null, 8, ["name"])
            ], !0)
          ]),
          _: 3
        })) : b("", !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), R = /* @__PURE__ */ K(j, [["__scopeId", "data-v-c3f83226"]]);
export {
  R as default
};
//# sourceMappingURL=design-system.es289.js.map
